import React, { useState } from 'react';
import { toast } from 'sonner';
import { Upload } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

// Stock Upload Button Component
function StockUploadBtn({ location, label, color }) {
  const [uploading, setUploading] = useState(false);
  const ref = React.useRef(null);
  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const res = await axios.post(`${API}/api/stock/upload/${location}`, fd);
      toast.success(`${label} updated: ${res.data.total_items} items`);
      window.dispatchEvent(new Event('stock-updated'));
    } catch (err) { toast.error(err.response?.data?.detail || 'Upload failed'); }
    setUploading(false);
    if (ref.current) ref.current.value = '';
  };
  return (
    <label className={`cursor-pointer flex items-center gap-1 px-2 py-1 bg-${color}-600 text-white rounded text-[10px] font-semibold hover:bg-${color}-700`}>
      <Upload className="w-3 h-3" /> {uploading ? '...' : label}
      <input ref={ref} type="file" accept=".xls,.xlsx" className="hidden" onChange={handleUpload} disabled={uploading} />
    </label>
  );
}

export default StockUploadBtn;
